export var SENTRY_RELEASE = "40500038d2a1a59f42150a8a249258b79c090012";
